import { IPricingWorkload } from "@shared/lib/types/pricingWorkload";
import { BackednResponse } from "@shared/lib/types/response";
import { Card, Typography } from "@shared/ui";
import { Select } from "@shared/ui/Select";
import { CircleUser } from "lucide-react";
import styles from "../styles.module.scss";

const { Title, Text } = Typography;

type ClosuresPageHeaderProps = {
  isSuperUser: boolean;
  pricingWorkloadData?: BackednResponse<IPricingWorkload[]>;
  isPricingWorkloadLoading: boolean;
  pocSelectOptions: { label: string; value: string }[];
  pocSelectValue: string | null;
  onPocChange: (userId: string) => void;
  selectedPoc: IPricingWorkload | null;
};

export function ClosuresPageHeader({
  isSuperUser,
  pricingWorkloadData,
  isPricingWorkloadLoading,
  pocSelectOptions,
  pocSelectValue,
  onPocChange,
  selectedPoc,
}: ClosuresPageHeaderProps) {
  return (
    <div className={styles.pageHeader}>
      <div className={styles.headerContent}>
        {/* <div className={styles.workspaceBadge}>
          <PackageCheck size={18} />
          Internal · POC workspace
        </div> */}
        <h1 className={styles.title}>
          My Closures
        </h1>
        {/* <Text type="secondary" className={styles.pageDescription}>
          Purchase closure tracking on your allocated briefs. Open a project to
          review commercials, timelines, and send purchase confirmation mail.
          Day-to-day pricing work stays in{" "}
          <Link to={ROUTES.MY_PRICING} className={styles.pricingLink}>
            My Pricing
          </Link>
          .
        </Text> */}
      </div>

      {isSuperUser ? (
        <Card
          className={styles.pocCard}
          title={
            <span className={styles.pocLabel}>
              <CircleUser size={14} />
              <Text type="secondary">Working as POC</Text>
            </span>
          }
        >
          {pricingWorkloadData ? (
            <Select
              options={pocSelectOptions}
              loading={isPricingWorkloadLoading}
              showSearch
              optionFilterProp="label"
              value={pocSelectValue}
              onChange={onPocChange}
              style={{ width: "100%" }}
              placeholder="Select a Pricing POC"
            />
          ) : null}
          {selectedPoc?.user?.emailId ? (
            <Text type="secondary" className={styles.pocEmail}>
              {selectedPoc.user.emailId}
            </Text>
          ) : null}
        </Card>
      ) : null}
    </div>
  );
}
